module.exports = __webpack_public_path__ + "static/media/loader_big.ece89406.svg";